const isPro = Object.is(process.env.NODE_ENV, 'production')
    // 后台域名配置
    //var adminName =  ''//接口地址-正式
    // var hostName = location.host;

//测试
// var hostName = 'https://defenh5-alpha.huatu.com';//h5域名
// var adminName = 'https://df-alpha.huatu.com'//接口地址

//beta
// var hostName = 'https://defenh5-beta.huatu.com';//h5域名
// var adminName = 'https://defen-beta.huatu.com'//接口地址


var hostName = window.location.protocol + "//" + window.location.host;
console.log(hostName)
console.log(window.location.protocol)
console.log(window.location.host)
var shareUrl = '';
var adminName = '';
var xyfwHostName = '';
var xyfwAdminName = '';
var websocketUrl_PK = '';
var playUrl = '';
if (hostName == 'https://defenh5-alpha.huatu.com' || hostName == 'http://defenh5-alpha.huatu.com') { //测试
    adminName = 'https://df-alpha.huatu.com';
    xyfwHostName = 'https://mmc-snjh5.huatu.com';
    xyfwAdminName = 'https://mmc-test.huatu.com';
    shareUrl = 'https://defenh5-alpha.huatu.com';
    websocketUrl_PK = "wss://defenh5-alpha.huatu.com/wss"; //测试服务器的地址(socket)
} else if (hostName == 'https://defenh5-beta.huatu.com' || hostName == 'http://defenh5-beta.huatu.com') { //预发布
    adminName = 'https://defen-beta.huatu.com';
    xyfwHostName = 'https://yk91.h5.huatu.com';
    xyfwAdminName = 'https://yk91.test.huatu.com';
    shareUrl = 'https://defenh5-beta.huatu.com';
    websocketUrl_PK = "wss://defenh5-beta.huatu.com/wss"; //beta服务器的地址(socket)
} else if (hostName == 'https://defenh5.huatu.com' || hostName == 'http://defenh5.huatu.com') {
    adminName = 'https://defen.huatu.com';
    xyfwHostName = 'https://fuwu.huatu.com';
    xyfwAdminName = 'https://mmc.ekao123.com';
    shareUrl = 'https://defenh5.huatu.com';
    // websocketUrl_PK = "wss://defenh5.huatu.com/wss";//beta服务器的地址(socket)
    websocketUrl_PK = "wss://defen.huatu.com/wss"; //beta服务器的地址(socket)
} else if (hostName == 'https://defenh5-tmp.huatu.com' || hostName == 'http://defenh5-tmp.huatu.com') {
    //2020.1.6 域名不再使用
    adminName = 'https://defen-tmp.huatu.com';
    xyfwHostName = 'https://fuwu.huatu.com';
    xyfwAdminName = 'https://mmc.ekao123.com';
    shareUrl = 'https://defenh5-tmp.huatu.com';
    websocketUrl_PK = "wss://defen-tmp.huatu.com/wss"; //正式服务器的地址(socket)
} else if (hostName == 'https://user.huatu.com' || hostName == 'http://user.huatu.com') { //华图教育+更名为华图教育 user版本域名
    adminName = 'https://defen.huatu.com';
    xyfwHostName = 'https://fuwu.huatu.com';
    xyfwAdminName = 'https://mmc.ekao123.com';
    shareUrl = 'https://user.huatu.com';
    websocketUrl_PK = "wss://defen.huatu.com/wss";
} else {
    adminName = 'https://df-alpha.huatu.com';
    xyfwHostName = 'http://mmc-snjh5.huatu.com';
    xyfwAdminName = 'http://mmc-test.huatu.com';
    shareUrl = 'https://defenh5-alpha.huatu.com';
    websocketUrl_PK = "wss://defenh5-alpha.huatu.com/wss"; //测试服务器的地址(socket)
    // adminName = 'https://defen-beta.huatu.com';
    // websocketUrl_PK ='ws://10.1.52.95:6543'
}


//var cas =  'https://cas.huatu.com'//单点登录地址-正式
//var cas =  'https://test-cas.huatu.com'//单点登录地址-测试
//var environment = 0;//是否为正式环境 1 正式环境 0 非正式环境

//let websocketUrl_PK = "ws://172.30.9.176:6543";//pk模块websocket的通信地址10.1.53.77:6543
//let websocketUrl_PK="ws://172.30.9.176:6543";//pk模块websocket的通信地址
//let websocketUrl_PK="wss://172.30.9.176:6543";//pk模块websocket的通信地址
//let websocketUrl_PK="wss://dfwss-alpha.huatu.com"



var websocketShareImgUrl_PK = ''; //pk模块分享到微聊的图片
module.exports = {
    baseURL: adminName,
    xyfuHostURL: xyfwHostName,
    xyfuBaseURL: xyfwAdminName,
    hostUrl: shareUrl,
    playUrl: hostName,
    websocketUrl_PK: websocketUrl_PK,
    websocketShareImgUrl_PK: websocketShareImgUrl_PK,
    // iosDownloadUrl : 'https://itunes.apple.com/cn/app/id1471472096',
    iosDownloadUrl: 'https://unaffected.huatu.com/app/scorenew?targetType=HTStartApp',
    // androidDownloadUrl : 'https://jrfile.huatu.com/app_version/htplus/android/HuatuEduPlus.apk',//华图教育+
    androidDownloadUrl: 'http://jrfile.huatu.com/app_version/hlpy/android/新华图教育.apk', //华图教育
}


//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 56